module.exports = __webpack_public_path__ + "img/deleteG.d8fc29ec.png";